import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import CheckCircleOutlineIcon from '@material-ui/icons/CheckCircleOutline';
import MenuBookIcon from '@material-ui/icons/MenuBook';
import PaymentIcon from '@material-ui/icons/Payment';
import RateReviewIcon from '@material-ui/icons/RateReview';
import ScheduleIcon from '@material-ui/icons/Schedule';
import SchoolIcon from '@material-ui/icons/School';
import { Alert, Snackbar } from "@mui/material";

import RadioButtonUncheckedIcon from '@material-ui/icons/RadioButtonUnchecked';
import {
  Box, Button, Step,
  StepLabel, Stepper, TextField, Typography
} from "@mui/material";
import Checkbox from "@mui/material/Checkbox";

import axios from "axios";
import { LoginContext } from 'contexts/LoginContext';
import useGetUserByUserName from 'hooks/userHooks/useGetUserByUserName';
import { useContext, useEffect, useMemo, useState } from "react";
import { useHistory } from "react-router-dom";
import ProgramService from 'services/ProgramServices/ProgramService';
import userService from 'services/userService';
import courseData from "../../StaticDataFiles/courseData.json";
import ReviewRow from './ReviewRow';

console.log(courseData, '-coursedata');

const COURSES = courseData?.courses || [];
const COURSE_SUBJECT_MAP = courseData?.courseSubjectMap || {};
const SUBJECT_DURATION_MAP = courseData?.subjectDurationMap || {};
const DURATION_MONTH_MAP = courseData?.durationMonthMap || {};

const GRADIENT = "linear-gradient(135deg, rgb(255, 113, 61) 0%, rgb(245, 159, 10) 100%)";

const CustomStepIcon = ({ active, completed, icon }) => {
  const ICONS = {
    1: <SchoolIcon />,
    2: <MenuBookIcon />,
    3: <ScheduleIcon />,
    4: <PaymentIcon />,
    5: <RateReviewIcon />,
  };

  return (
    <Box
      sx={{
        width: 40,
        height: 40,
        borderRadius: "50%",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        background: active || completed ? GRADIENT : "transparent",
        border: active || completed ? "none" : "1px solid #ddd",
        color: active || completed ? "#fff" : "#9e9e9e",
        transition: "all 0.3s ease",
      }}
    >
      {completed ? <CheckCircleIcon /> : ICONS[icon]}
    </Box>
  );
};


const steps = [
  { label: "Choose Courses", description: 'Select the courses your institute will offer. You can choose multiple.', icon: <SchoolIcon /> },
  { label: "Choose Subjects", description: 'Select the subjects based on your chosen courses.', icon: <MenuBookIcon /> },
  { label: "Course Duration", description: 'Choose the duration of your course program. (You can customize fee slabs, after login.)', icon: <ScheduleIcon /> },
  // { label: "Fee Structure", description: 'Optionally set up your fee structure and installment plans.', icon: <PaymentIcon /> },
  { label: "Review Setup", description: '', icon: <RateReviewIcon /> },
];


const CourseSetupWizard = ({ onSubmit, providerId, userData }) => {
  const history = useHistory();

  const {
    setUser,
    setUserId,
    setUserPrivileges,
    setProviderId,
    setProviderType,
    setUserType,
    setContentProviderIds,
    setLicensePackageObject,
    setShowTrialAlert,
    setProviderValidTo
  } = useContext(LoginContext);

  const {
    data: loginDetails,
    mutate: getUserDetails
  } = useGetUserByUserName();

  const [loading, setLoading] = useState(false);
  const [snackbar, setSnackbar] = useState({
    open: false,
    message: "",
    severity: "success", // success | error | warning | info
  });

  const [activeStep, setActiveStep] = useState(0);
  const [data, setData] = useState({
    courses: [],
    subjects: [],
    programs: [],
    // duration: "",
    // customDuration: "",
    // totalFees: "",
    // installments: "",
    // slabs: [],
    // enableInstallments: false,
    // installmentDuration: "Monthly",
  });

  const [customCourse, setCustomCourse] = useState("");
  const [customSubjects, setCustomSubjects] = useState([]);
  const [customSubjectInput, setCustomSubjectInput] = useState("");

  const [customDurations, setCustomDurations] = useState([
    "One Year Program",
    "Two Year's Program",
    "Crash Course"
  ]);
  const [customDurationInput, setCustomDurationInput] = useState("");
  const progress = ((activeStep + 1) / steps.length) * 100;

  const availableSubjects = useMemo(() => {
    // If OTHER selected → use custom subjects
    if (data.courses.includes("OTHER")) {
      return customSubjects;
    }

    const set = new Set();
    data.courses.forEach((c) =>
      COURSE_SUBJECT_MAP[c]?.forEach((s) => set.add(s))
    );
    return Array.from(set);
  }, [data.courses, customSubjects]);

  const durationOptions = useMemo(() => {
    const set = new Set();

    // If OTHER → use custom durations
    if (data.courses.includes("OTHER")) {
      data.subjects.forEach((s) =>
        SUBJECT_DURATION_MAP["Physics"]?.forEach((d) => set.add(d))
      );
      return Array.from(set);
    }
    data.subjects.forEach((s) =>
      SUBJECT_DURATION_MAP[s]?.forEach((d) => set.add(d))
    );
    return Array.from(set);
  }, [data.subjects, customDurations]);

  useEffect(() => {
    if (!data.totalFees || !data.installments) return;

    const per = Math.floor(data.totalFees / data.installments);
    const rem = data.totalFees % data.installments;

    const perDuration = Math.floor(
      (data.durationInMonths || 0) / data.installments
    );

    setData((p) => ({
      ...p,
      slabs: Array.from({ length: data.installments }, (_, i) => ({
        name: `Installment ${i + 1}`,
        amount: i === data.installments - 1 ? per + rem : per,
        durationInMonths:
          i === data.installments - 1
            ? (data.durationInMonths || 0) - perDuration * (data.installments - 1)
            : perDuration,
      })),
    }));
  }, [data.totalFees, data.installments]);

  useEffect(() => {
    if (!loginDetails?.userDetails) return;

    let privileges = loginDetails?.privilegeObject
      ? JSON.parse(loginDetails?.privilegeObject)
      : "";

    let licensePackage = loginDetails?.licenseObject
      ? JSON.parse(loginDetails?.licenseObject)
      : "";

    setLicensePackageObject(licensePackage);
    setUserPrivileges(privileges?.Value);
    setUser(loginDetails?.userDetails?.userName);
    setUserId(loginDetails?.userDetails?.userId);
    setProviderId(loginDetails?.userDetails.providerId);
    setProviderType(loginDetails?.userDetails.providerTypeId);
    setContentProviderIds(
      loginDetails?.userDetails.contentProviderIds["$values"]
    );
    setUserType(loginDetails?.userDetails.userTypeId);
    setShowTrialAlert(privileges?.Value?.PackageId === 4);
    setProviderValidTo(loginDetails?.userDetails?.validTo);

    axios.defaults.headers.common = {
      providerId: loginDetails?.userDetails.providerId,
      contentProviderIds:
        loginDetails?.userDetails?.contentProviderIds["$values"]
    };

    userService.updateLoginDate(loginDetails?.userDetails?.userId);

    history.push("/admin");

  }, [loginDetails]);


  // helpers

  const addInstallment = () => {
    setData((p) => {
      const remaining =
        p.totalFees -
        p.slabs.reduce((sum, s) => sum + Number(s.amount || 0), 0);

      return {
        ...p,
        slabs: [
          ...p.slabs,
          {
            id: Date.now(),
            name: `Installment ${p.slabs.length + 1}`,
            amount: remaining > 0 ? remaining : 0,
            durationInMonths: 1,
          },
        ],
      };
    });
  };


  // const slabsTotal = useMemo(
  //   () => data.slabs.reduce((sum, s) => sum + Number(s.amount || 0), 0),
  //   [data.slabs]
  // );

  // const pendingAmount = useMemo(
  //   () => Number(data.totalFees || 0) - slabsTotal,
  //   [data.totalFees, slabsTotal]
  // );


  const canProceed = () => {
    switch (activeStep) {
      case 0:
        return data.courses.length > 0;
      case 1:
        return (data.subjects.length > 0 || customSubjects?.length > 0);
      case 2:
        return data.programs.length > 0 &&
          data.programs.every(p => p.totalFees > 0);
      // return Boolean(data.duration || data.customDuration);
      // case 3:
      // if (!data.totalFees) return false;

      // if (!data.enableInstallments) return true;

      // return (
      //   data.slabs.length > 0 &&
      //   slabsTotal === Number(data.totalFees)
      // );
      // return data.totalFees > 0 && data.installments > 0;
      default:
        return true;
    }
  };

  const createProgram = async (data) => {
    const durationTotal = data.slabs.reduce(
      (sum, s) => sum + Number(s.durationInMonths || 0),
      0
    );

    if (durationTotal > data.durationInMonths) {
      showSnackbar(
        "Sum of installment durations must equal program duration",
        "warning"
      );
      return;
    }

    try {
      setLoading(true);
      /* -----------------------------
         1 CREATE PROGRAM PAYLOAD
      ----------------------------- */

      const programPayload = {
        providerId: providerId, // replace if dynamic
        code: data.duration?.toUpperCase().replace(/\s+/g, "-"),
        name: data.duration,
        description: "",
        durationInMonths: data.durationInMonths,
        baseFee: data.totalFees,
        createdBy: "system",
        updatedBy: "system",
      };

      const programRes =
        await ProgramService.createProgram(programPayload);

      const programId =
        programRes?.id || programRes?.programId;

      if (!programId) {
        throw new Error("Program ID not returned");
      }

      /* -----------------------------
         2 CREATE INSTALLMENT SLABS
      ----------------------------- */

      if (data.enableInstallments && data.slabs.length > 0) {
        const slabsPayload = data.slabs.map((slab, index) => ({
          slabName: slab.name,
          amount: Number(slab.amount),
          durationInMonths: Number(slab.durationInMonths),
          sequenceOrder: index + 1,
        }));


        await ProgramService.addSlab(programId, slabsPayload);
      }

      showSnackbar("Program created successfully 🎉", "success");

      setTimeout(() => {
        onSubmit(); // move to next screen / close modal
      }, 3000);

    } catch (error) {
      console.error(error);
      showSnackbar(
        error?.response?.data?.message ||
        "Failed to create program. Please try again.",
        "error"
      );
    } finally {
      setLoading(false);
    }
  };

  const createProgramsBulk = async () => {
    try {
      setLoading(true);

      const programsPayload = data.programs.map((program, index) => ({
        providerId: providerId,
        code: program.duration
          .toUpperCase()
          .replace(/\s+/g, "-"),

        name: program.duration,
        description: program.duration,
        durationInMonths: program.durationInMonths,
        baseFee: Number(program.totalFees),
        createdBy: "system",
        slabs: []   // empty slabs as requested
      }));

      const finalPayload = {
        providerSubjects: data?.subjects?.length > 0 ? data?.subjects : [],
        programs: programsPayload
      };

      console.log("Bulk Payload:", finalPayload);

      await ProgramService.bulkCreatePrograms(finalPayload);

      showSnackbar("Programs created successfully 🎉", "success");
      // Auto Login Trigger
      const { user } = JSON.parse(localStorage.getItem("authUser")) || {};

      setTimeout(() => {
        getUserDetails(userData?.email);
      }, 2000);

    } catch (error) {
      console.error(error);
      showSnackbar(
        error?.response?.data?.message ||
        "Bulk program creation failed.",
        "error"
      );
    } finally {
      setLoading(false);
    }
  };


  const showSnackbar = (message, severity = "success") => {
    setSnackbar({ open: true, message, severity });
  };

  const handleSkipSetup = () => {
    try {
      setLoading(true);

      // get stored user (same logic used after bulk create)
      const { user } = JSON.parse(localStorage.getItem("authUser")) || {};

      if (userData?.email) {
        //auto login
        getUserDetails(userData.email);
      } else if (user) {
        getUserDetails(user);
      } else {
        history.push("/admin");
      }

      showSnackbar("You can complete setup later from dashboard", "info");
    } catch (error) {
      console.error(error);
      history.push("/admin");
    } finally {
      setLoading(false);
    }
  };


  const finalCourses = data?.courses?.includes("OTHER")
    ? [...data?.courses.filter(c => c !== "OTHER"), customCourse]
    : data?.courses;

  return (
    <Box>
      {(activeStep !== steps.length - 1) && <Box
        display="flex"
        alignItems="center"
        justifyContent="space-between"
        mb={2}
      >
        <Typography fontSize={13} color="text.secondary">
          Step {activeStep + 1} of {steps.length}
        </Typography>

        <Typography
          fontWeight={600}
          color="text.secondary"
        // sx={{
        //   background: GRADIENT,
        //   WebkitBackgroundClip: "text",
        //   WebkitTextFillColor: "transparent",
        // }}
        >
          {steps[activeStep].label}
        </Typography>
      </Box>}

      {(activeStep !== steps.length - 1) && <Stepper activeStep={activeStep} alternativeLabel sx={{ mb: 3, textAlign: 'left' }}>
        {steps.map((step, index) => (
          <Step key={step.label}>
            <StepLabel StepIconComponent={CustomStepIcon} />
            {/* <StepLabel StepIconComponent={CustomStepIcon}>
              <Typography fontSize={13}>{step.label}</Typography>
            </StepLabel> */}
          </Step>
        ))}
      </Stepper>}

      <Typography fontSize={13} mb={2} color="text.secondary">
        {steps[activeStep].description}
      </Typography>

      {/* <Typography variant="h6">Course Setup</Typography>
      <Typography fontSize={13} color="text.secondary">
        Step {activeStep + 1} of {steps.length}
      </Typography>

      <LinearProgress value={progress} variant="determinate" sx={{ my: 2 }} /> */}

      {/* STEP 0 */}
      {activeStep === 0 &&
        (<>
          {COURSES?.map((c) => (
            <Box
              key={c.key}
              onClick={() =>
                setData((p) => ({
                  ...p,
                  courses: p.courses.includes(c.key)
                    ? p.courses.filter((x) => x !== c.key)
                    : [...p.courses, c.key],
                }))
              }
              sx={{
                border: "1px solid",
                borderColor: data.courses.includes(c.key)
                  ? '#ff713d'
                  : "grey.300",
                borderRadius: 2,
                p: 2,
                mb: 1.5,
                cursor: "pointer",
                display: "flex",
                gap: 2
              }}
            >
              <Checkbox
                checked={data.courses.includes(c.key)}
                sx={{
                  color: "#ff713d",
                  "&.Mui-checked": { color: "#ff713d" },
                  padding: 0,
                  width: 24,
                  height: 24,
                }}
                icon={<RadioButtonUncheckedIcon sx={{ color: "#ccc" }} />}
                checkedIcon={<CheckCircleIcon sx={{ color: "#ff713d" }} />}
              />
              <Box>
                <Typography fontWeight={600}>{c.title}</Typography>
                <Typography fontSize={13} color="text.secondary">
                  {c.desc}
                </Typography>
              </Box>
            </Box>
          ))}
          {/* OTHER COURSE OPTION */}
          <Box
            onClick={() => {
              if (!data.courses.includes("OTHER")) {
                setData((p) => ({
                  ...p,
                  courses: [...p.courses, "OTHER"],
                }));
              }
            }}
            sx={{
              border: "1px solid",
              borderColor: data.courses.includes("OTHER")
                ? '#ff713d'
                : "grey.300",
              borderRadius: 2,
              p: 2,
              mb: 1.5,
              cursor: "pointer",
              display: "flex",
              gap: 2
            }}
          >
            <Checkbox
              checked={data.courses.includes("OTHER")}
              sx={{
                color: "#ff713d",
                "&.Mui-checked": { color: "#ff713d" },
                padding: 0,
                width: 24,
                height: 24,
              }}
              icon={<RadioButtonUncheckedIcon sx={{ color: "#ccc" }} />}
              checkedIcon={<CheckCircleIcon sx={{ color: "#ff713d" }} />}
            />

            <Box width="100%">
              <Typography fontWeight={600}>OTHER</Typography>

              {data.courses.includes("OTHER") && (
                <TextField
                  fullWidth
                  placeholder="Enter your course name"
                  size="small"
                  sx={{ mt: 1 }}
                  value={customCourse}
                  onChange={(e) => setCustomCourse(e.target.value)}
                />
              )}
            </Box>
          </Box>
        </>)}


      {/* STEP 1 */}
      {activeStep === 1 && (
        <>
          {availableSubjects?.map((s) => {
            const selected = data.subjects.includes(s);

            return (
              <Box
                key={s}
                onClick={() =>
                  setData((p) => ({
                    ...p,
                    subjects: selected
                      ? p.subjects.filter((x) => x !== s)
                      : [...p.subjects, s],
                  }))
                }
                sx={{
                  border: "1px solid",
                  borderColor: selected ? '#ff713d' : "grey.300",
                  borderRadius: 2,
                  p: 2,
                  mb: 1.5,
                  cursor: "pointer",
                  display: "flex",
                  alignItems: "center",
                  gap: 2
                }}
              >
                <Checkbox
                  checked={data.subjects.includes(s)}
                  sx={{
                    color: "#ff713d",
                    "&.Mui-checked": { color: "#ff713d" },
                    padding: 0,
                    width: 24,
                    height: 24,
                  }}
                  icon={<RadioButtonUncheckedIcon sx={{ color: "#ccc" }} />}
                  checkedIcon={<CheckCircleIcon sx={{ color: "#ff713d" }} />}
                />
                <Typography fontWeight={600}>{s}</Typography>
              </Box>
            );
          })}
          {data.courses.includes("OTHER") && (
            <Box mt={2}>
              <TextField
                fullWidth
                placeholder="Add subject (e.g. Physics)"
                helperText="Type subject name and press Enter"
                value={customSubjectInput}
                onChange={(e) => setCustomSubjectInput(e.target.value)}
                onKeyDown={(e) => {
                  if (e.key === "Enter" && customSubjectInput.trim()) {
                    if (!customSubjects.includes(customSubjectInput.trim())) {
                      setCustomSubjects((prev) => [
                        ...prev,
                        customSubjectInput.trim(),
                      ]);
                    }
                    setCustomSubjectInput("");
                  }
                }}
              />
            </Box>
          )}
        </>
      )}


      {/* STEP 2 */}
      {/* STEP 2 */}
      {activeStep === 2 && (
        <>
          {durationOptions?.map((d) => {
            const selected = data.programs.some(
              (p) => p.duration === d
            );

            return (
              <Box
                key={d}
                sx={{
                  border: "1px solid",
                  borderColor: selected ? "#ff713d" : "grey.300",
                  borderRadius: 2,
                  p: 2,
                  mb: 2,
                }}
              >
                <Box
                  display="flex"
                  alignItems="center"
                  sx={{
                    cursor: "pointer",
                    display: "flex",
                    alignItems: "center",
                    gap: 2
                  }}
                  onClick={() => {
                    setData((prev) => ({
                      ...prev,
                      programs: selected
                        ? prev.programs.filter((p) => p.duration !== d)
                        : [
                          ...prev.programs,
                          {
                            duration: d,
                            durationInMonths: DURATION_MONTH_MAP[d] || 0,
                            totalFees: ""
                          }
                        ]
                    }));
                  }}
                >
                  <Checkbox
                    checked={selected}
                    sx={{
                      color: "#ff713d",
                      "&.Mui-checked": { color: "#ff713d" },
                      padding: 0,
                      width: 24,
                      height: 24,
                    }}
                    icon={<RadioButtonUncheckedIcon sx={{ color: "#ccc" }} />}
                    checkedIcon={<CheckCircleIcon sx={{ color: "#ff713d" }} />}
                  />

                  <Typography fontWeight={600}>{d}</Typography>
                </Box>

                {/* Show Fees Input if selected */}
                {selected && (
                  <TextField
                    fullWidth
                    label="Total Course Fees (₹)"
                    type="number"
                    margin="normal"
                    inputProps={{ min: 0 }}
                    value={
                      data.programs.find((p) => p.duration === d)?.totalFees || ""
                    }
                    onChange={(e) => {
                      const value = +e.target.value;

                      setData((prev) => ({
                        ...prev,
                        programs: prev.programs.map((p) =>
                          p.duration === d
                            ? { ...p, totalFees: value }
                            : p
                        )
                      }));
                    }}
                  />
                )}
              </Box>
            );
          })}
        </>
      )}

      {/* STEP 3 */}
      {activeStep === 3 && (
        <>
          {/* Green check */}
          <Box
            display="flex"
            justifyContent="center"
            mb={2}
          >
            <Box
              sx={{
                width: 70,
                height: 70,
                borderRadius: "50%",
                background: "#dcfce7",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <CheckCircleOutlineIcon
                style={{ fontSize: 40, color: "#21C45D" }}
              />
            </Box>
          </Box>

          <Typography
            variant="h6"
            align="center"
            fontWeight={600}
            sx={{ textTransform: 'capitalize' }}
          >
            Review Your Setup
          </Typography>

          <Typography
            fontSize={13}
            color="text.secondary"
            align="center"
            mb={3}
          >
            Please review your course configuration before finishing.
          </Typography>

          {/* Review Card */}
          <Box
            sx={{
              border: "1px solid #e5e7eb",
              borderRadius: 2,
              p: 2.5,
            }}
          >
            <ReviewRow label="Courses" value={finalCourses?.join(", ")} />
            <ReviewRow label="Subjects" value={data.subjects.join(", ")} />
            {data.programs.map((p, i) => (
              <ReviewRow
                key={i}
                label={`${p.duration}`}
                value={`₹ ${Number(p.totalFees).toLocaleString()}`}
              />
            ))}

            {/* <ReviewRow label="Duration" value={data.duration} />
            <ReviewRow
              label="Total Fees"
              value={`₹${data.totalFees.toLocaleString()}`}
            /> */}
            {/* <ReviewRow
              label="Installments"
              value={
                data.enableInstallments
                  ? `${data.slabs.length} (${data.installmentDuration})`
                  : "Single Payment"
              }
            // value={
            //   data.enableInstallments
            //     ? `${data.slabs.length} × ₹${(
            //       data.totalFees / data.slabs.length
            //     ).toLocaleString()} (${data.installmentDuration})`
            //     : "Single Payment"
            // }
            /> */}
          </Box>
        </>
      )}

      {/* {activeStep === 4 && (
        <>
          <Typography fontWeight={600}>Review Your Setup</Typography>
          <Typography>Courses: {data.courses.join(", ")}</Typography>
          <Typography>Subjects: {data.subjects.join(", ")}</Typography>
          <Typography>
            Duration: {data.duration || data.customDuration}
          </Typography>
          <Typography>Total Fees: ₹{data.totalFees}</Typography>
          <Typography>
            Installments: {data.installments}x ₹
            {Math.floor(data.totalFees / data.installments)}
          </Typography>
        </>
      )} */}

      <Box display="flex" justifyContent="space-between" mt={3}>
        <Button
          sx={{ color: '#ff713d' }}
          disabled={activeStep === 0}
          onClick={() => setActiveStep(s => s - 1)}
        >
          Back
        </Button>

        <Box display="flex" gap={2}>
          {/* Later Button */}
          <Button
            variant="contained"
            disabled={loading}
            onClick={handleSkipSetup}
            sx={{
              textTransform: "none",
              borderColor: "#9e9e9e",
              background: GRADIENT,
              color: "#fff",
              minWidth: 140,
              px: 4,
              "&:hover": { borderColor: "#555" }
            }}
          >
            Later
          </Button>

          {/* Next / Complete */}
          <Button
            variant="contained"
            disabled={!canProceed() || loading}
            onClick={() => {
              if (activeStep === 1 && data.courses.includes("OTHER")) {
                setData((prev) => ({
                  ...prev,
                  subjects: customSubjects
                }));
              }

              activeStep === steps.length - 1
                ? createProgramsBulk()
                : setActiveStep(s => s + 1)
            }
            }
            sx={{
              background: activeStep === steps.length - 1 ? '#21C45D' : GRADIENT,
              color: "#fff",
              textTransform: "none",
              "&:hover": {
                background: GRADIENT,
                opacity: 0.9,
              },
            }}
          >
            {loading
              ? "Processing..."
              : activeStep === steps.length - 1
                ? "Complete Setup"
                : "Next"}
          </Button>
        </Box>
      </Box>

      {/* <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={loading}
      >
        <CircularProgress color="inherit" />
      </Backdrop> */}
      <Snackbar
        open={snackbar.open}
        autoHideDuration={4000}
        onClose={() => setSnackbar((s) => ({ ...s, open: false }))}
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
      >
        <Alert
          onClose={() => setSnackbar((s) => ({ ...s, open: false }))}
          severity={snackbar.severity}
          variant="filled"
          sx={{ width: "100%" }}
        >
          {snackbar.message}
        </Alert>
      </Snackbar>

    </Box>
  );
};

export default CourseSetupWizard;
